import { Component, OnInit, Inject, OnDestroy } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { SessionStorageService } from 'angular-web-storage';
import { OtpDialogService } from './otp-dialog.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-otp-dialog',
  templateUrl: './otp-dialog.component.html',
  styleUrls: ['./otp-dialog.component.scss']
})
export class OtpDialogComponent implements OnInit, OnDestroy {
  enteredOtp: string = '';
  loading: boolean = false;
  remainingTime: number = 0;
  private timerSub: Subscription;
  approvalCodeView: boolean;
  emailCodeView: boolean;
  otpSendMessage: string
  otpFailedMsg: string;
  masterEmails; string;
  showFaliedMsgVerified: boolean = false;
  showFaliedMsgLength: boolean = false;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data,
    private dialogRef: MatDialogRef<OtpDialogComponent>,
    public session: SessionStorageService,
    public otpService: OtpDialogService
  ) { }

  ngOnInit() {
    console.log('🚀 Dialog initialized with data:', this.data);
    console.log('==approvalOtpActive==', this.data.type === 'approvalOtpActive');
    console.log('==emailOtpActive==', this.data.type === 'emailOtpActive');
    console.log('==vesselId==', this.data.vesselId);

    if (this.data.type === 'approvalOtpActive') {
      this.emailCodeView = false;
      this.approvalCodeView = true;
    } else {
      this.emailCodeView = true;
      this.approvalCodeView = false;
    }


    // Subscribe to shared timer
    this.timerSub = this.otpService.getOtpTimerObservable().subscribe(time => {
      console.log('==ngOnInit-getOtpTimerObservable-time==', time);
      this.remainingTime = time;
      console.log('==ngOnInit-remainingTime==', this.remainingTime);
    });

    console.log('==ngoninit-getIsOtpActive==', this.otpService.getIsOtpActive())
    console.log('==ngoninit-opposit-getIsOtpActive==', !this.otpService.getIsOtpActive())
  }

  ngOnDestroy() {
    if (this.timerSub) {
      this.timerSub.unsubscribe();
    }
  }

  onResend() {
    const userId: number | null = this.session.get('userid');
    if (userId) {
      this.loading = true;
      this.otpService.sendOtpToMaster(userId, this.data.vesselId).subscribe(response => {
        this.loading = false;
        if (response.responsecode === 200) {
          this.otpService.resetTimer(); // Reset shared timer
          const emails = response.masterEmail.split(',');
          this.masterEmails = emails.length > 0 ? emails[0].trim() : '';
          console.log('First master email:', this.masterEmails);
        } else {
          console.log('Failed to resend OTP');
        }
      }, error => {
        this.loading = false;
        console.error('Error in resend OTP', error);
      });
    }
  }

  verifyOtp() {

      // Check if OTP is entered
  if (!this.enteredOtp || this.enteredOtp.trim().length === 0) {
    this.showFaliedMsgVerified = true;
    // Set showFaliedMsg to true after 2 seconds
    setTimeout(() => {
      this.showFaliedMsgVerified = false;
    }, 2000);
    return;
  }

  // Check if OTP is exactly 6 digits
  if (this.enteredOtp.length !== 6) {
    this.showFaliedMsgLength = true;
    // Set showFaliedMsg to true after 2 seconds
    setTimeout(() => {
      this.showFaliedMsgLength = false;
    }, 2000);
    return;
  }

    this.loading = true;

    const userId: number | null = this.session.get('userid');
    const otpRequest = {
      "otp": this.enteredOtp,
      "userId": userId
    }

    this.otpService.verifyOtpByMaster(otpRequest).subscribe(
      (data) => {
        this.loading = false;
        if (data.responsecode == 200) {
          this.dialogRef.close(true);
        } else {
          this.dialogRef.close(false);
        }
      }, (error) => {
        this.loading = false;
        console.error('OTP verification failed', error);
      }
    )
  }

  closeDialog() {
    this.dialogRef.close('cancel');
  }

  async getOtpViaEmail() {
    console.log('[INFO] Request to resend OTP initiated.');

    this.setLoading(true);
    const userId: number | null = this.session.get('userid');
    console.log(`[INFO] Logged-in user ID: ${userId}`);
    console.log('==otpService-getIsOtpActive==', this.otpService.getIsOtpActive())
    console.log('==otpService-opposit-getIsOtpActive==', !this.otpService.getIsOtpActive())

    if (!this.otpService.getIsOtpActive()) {
      const data = await this.otpService.sendOtpToMaster(userId, this.data.vesselId).toPromise();
      if (data.responsecode === 200) {
        this.approvalCodeView = false;
        this.emailCodeView = true;
        this.setLoading(false);
        const emails = data.masterEmail.split(',');
        this.masterEmails = emails.length > 0 ? emails[0].trim() : '';
        console.log('First master email:', this.masterEmails);
        this.otpSendMessage = 'OTP sent successfully to your email';
        setTimeout(() => {
          this.otpSendMessage = '';
        }, 3000); // 3 seconds

        this.otpService.startTimer(); // Start timer only after successful OTP send
      }
      else {
        console.error('[ERROR] OTP send failed. Please try again later.');
        this.setLoading(false);
        this.otpFailedMsg = 'There was an issue sending the OTP. Please try again shortly.';
        setTimeout(() => {
          this.otpFailedMsg = '';
        }, 3000); // 3 seconds
      }
    }
  }

  private setLoading(state: boolean) {
    this.loading = state;
  }

  formatTimeLeft(totalSeconds: number): string {
    const hours = Math.floor(totalSeconds / 3600);
    const minutes = Math.floor((totalSeconds % 3600) / 60);
    const seconds = totalSeconds % 60;
    const pad = (num: number): string => num.toString().padStart(2, '0');
    return `${pad(hours)}:${pad(minutes)}:${pad(seconds)}`;
  }


}
